import { useSelector } from "react-redux";
import { getUserProfile } from '../application/selectors/users';
import { getCompany } from '../application/selectors/company';
import useCognito from "./useCognito";


const useWhoAmI = () => {
  const profile = useSelector(getUserProfile);
  const company = useSelector(getCompany);
  const { user, isAdmin, loading } = useCognito();

  const isCompany = !!Object.keys(company).length
  const userProfile = isCompany ? company : profile

  const username = user?.username || ''
  const identities = user?.attributes?.identities
  const isFederated = username.startsWith('Google_')
    || username.startsWith('Facebook_')
    || username.startsWith('SignInWithApple_')
    || (typeof identities === 'string' && identities.length > 0)

  return { isCompany, userProfile, isFederated, isAdmin, loading }
};

export default useWhoAmI;